import { match as redirect } from "../../../src/params/redirect.js";

export const matchers = { redirect };